import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ja from './legacy-ja-map.json'
import en from './legacy-en-map.json'
import { apiJa, apiEn } from './api-message-map'

Vue.use(VueI18n)

Object.assign(ja, apiJa)
Object.assign(en, apiEn)

const zh = Object.keys(ja).reduce((messages, key) => {
  messages[key] = key
  return messages
}, {})

const savedLocale = localStorage.getItem('site-locale')
const locale = ['zh-CN', 'ja-JP', 'en-US'].includes(savedLocale) ? savedLocale : 'zh-CN'

export default new VueI18n({
  locale,
  fallbackLocale: 'zh-CN',
  silentTranslationWarn: true,
  messages: {
    'zh-CN': zh,
    'ja-JP': ja,
    'en-US': en
  }
})